import { Trans, useLingui } from "@lingui/react/macro";
import { useState } from "react";
import { useParams } from "react-router-dom";

import {
  apiGetClinicalStudiesStudyAcronymOverviewOverall,
  PerPatientStudyStatsSimple,
} from "../../api";
import { ApiConnector } from "../../api/api-connector";
import { FormRow } from "../../components/ui-kit/form/form-row";
import { FormTable } from "../../components/ui-kit/form/form-table";
import { Spinner } from "../../components/ui-kit/spinner";
import { assertStudyAcronym } from "../../utils/clinical-studies";
import { useFetch } from "../../utils/use-fetch";
import { OverviewTable } from "./overview-table.tsx";

export function OverviewRoute(props: { api: ApiConnector }) {
  const { t } = useLingui();
  const { name } = useParams<{ name: string }>();
  const study = assertStudyAcronym(name);
  const [data, setData] = useState<any>(null);

  const { loading } = useFetch(async () => {
    const result = (
      await apiGetClinicalStudiesStudyAcronymOverviewOverall({
        path: { study_acronym: study },
      })
    ).data;
    setData(result);
  }, [study]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <FormTable>
        <FormRow label={t`Full title`} data={data.full_title} />

        <FormRow label={t`Planned patients`} data={data.planned_patients} />

        <FormRow label={t`No. planned visits`} data={data.no_planned_visits} />

        <FormRow label={t`Enrolled patients`} data={data.enrolled_patients} />
      </FormTable>

      <h2 className="mt-10 mb-2 text-base font-bold">
        <Trans>Patient visits</Trans>
      </h2>

      <OverviewTable
        data={data.visits_per_patients as PerPatientStudyStatsSimple[]}
        study={study}
      />
    </>
  );
}
